import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Environment } from 'dashboard/models/environment';
import { Verification } from 'dashboard/models/verification';
import { setVerifications, VerificationsFilterParams } from 'dashboard/redux/actions/verifications';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadVerificationsList({
  currentEnvironment,
  currentPage,
  pageSize,
  sortParams,
  filters,
  abortSignal,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  sortParams: SortParams;
  filters: VerificationsFilterParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const params = createParamsForList(currentEnvironment, filters, sortParams);
    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    } as any;

    const verificationsResponse = await SessionClientDashboard.listResource<
      Verification,
      PaginationParams
    >(ApiEndpoint.Verification, paramsFull);

    const verifications = verificationsResponse.data;
    const paginationParams = verificationsResponse.meta;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setVerifications(verifications, currentEnvironment, paginationParams));
  };
}

function governmentIdProperties(verificationFilters: VerificationsFilterParams) {
  const { type, issuingSubdivisions, governmentIdTypes, issuingCountries } = verificationFilters;
  // subdivision should be in ISO-3166-2 format, e.g. US-CA
  // omit subdivisions if corresponding country codes not selected
  const subdivisions = [...(issuingSubdivisions || [])].filter((subdivision) =>
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    issuingCountries.includes(subdivision.split('-')[0]),
  );
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return !type.includes(ApiModel.VerificationGovernmentId)
    ? {}
    : {
        'issuing-subdivisions': subdivisions,
        'government-id-types': governmentIdTypes,
        'issuing-countries': issuingCountries,
      };
}

function createParamsForList(
  currentEnvironment: Environment,
  verificationFilters: VerificationsFilterParams,
  verificationSortParams: SortParams,
) {
  const {
    createdAtStart,
    createdAtEnd,
    updatedAtStart,
    updatedAtEnd,
    status,
    tagIds,
    type,
    omni,
    checks,
    inquiryTemplateIds,
    verificationTemplateIds,
  } = verificationFilters;
  const { sort, shouldSortDescending } = verificationSortParams;

  const filter = {
    'environment-id': currentEnvironment.id,
    'created-at-start': createdAtStart?.toString(),
    'created-at-end': createdAtEnd?.toString(),
    'updated-at-start': updatedAtStart?.toString(),
    'updated-at-end': updatedAtEnd?.toString(),
    status,
    'tag-ids': tagIds,
    type,
    omni,
    checks,
    'inquiry-template-ids': inquiryTemplateIds,
    'verification-template-ids': verificationTemplateIds,
    ...governmentIdProperties(verificationFilters),
  };

  return {
    filter,
    sort: `${shouldSortDescending ? '-' : ''}${sort}`,
  };
}
